export default function (page = 1, limit = 25, sort = null) {
	this.page = page || 0
	this.limit = limit || 25
	this.sort = sort || null
}
